import { __extends, __rest, __assign } from 'tslib';
import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-loader.css';

var getClassNameList = classNames.bind(styles);
var Loader = /** @class */ (function (_super) {
    __extends(Loader, _super);
    function Loader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Loader.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, isDarkBackground = _b.isDarkBackground, isSmall = _b.isSmall, l10n = _b.l10n, title = _b.title, props = __rest(_b, ["className", "isDarkBackground", "isSmall", "l10n", "title"]);
        var loaderTitle = title || l10n.formatText('loading');
        var baseClassName = 'uitk-loader';
        var cssClassNames = getClassNameList(baseClassName, className, (_a = {},
            _a["".concat(baseClassName, "-dark")] = isDarkBackground,
            _a["".concat(baseClassName, "-small")] = isSmall,
            _a));
        var reducedMotionClassNames = getClassNameList("".concat(baseClassName, "-has-reduced-motion"));
        var useReducedMotion = false;
        if (typeof window !== 'undefined') {
            useReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        }
        return (React.createElement("span", __assign({ className: useReducedMotion ? "".concat(cssClassNames, " ").concat(reducedMotionClassNames) : cssClassNames, title: loaderTitle, "aria-label": loaderTitle }, props)));
    };
    Loader.displayName = 'UitkLoader';
    Loader.defaultProps = {
        isDarkBackground: false,
        isSmall: false
    };
    return Loader;
}(React.Component));
var UitkLoader = function (props) {
    var l10n = useLocalization();
    return React.createElement(Loader, __assign({ l10n: l10n }, props));
};

export { Loader, UitkLoader };
